import { checkInputAsInteger, isValid } from "./utilitiesmodule";

export function installVueDirectives(Vue) {

    /******************************************NUMBER****************************************************************************************************/
    Vue.directive('number', {
        inserted(el, _, vnode) {

            //Evento scatenato dopo l'input: rimuove tutti i caratteri che non sono numeri e permette la cancellazione
            //L'evento beforeinput non va bene perchè non tiene conto del cambiamento dei dati attraverso le frecce (esempio 1) o l'inserimento di un numero non alla fine (esempio 2).
            //Esempio 1: Se il valore attuale è di 200 e si premeva la freccia in avanti, si concatenava 200 a 201, formando il numero 200201. 
            //Invece si voleva semplicemente sostituire 200 con 201.
            //Esempio 2: Se il valore attuale è di 3, ma si vuole il numero 13, l'utente deve aggiungere 1 davanti, ma 1 veniva concatenato dopo il 3, ottenendo 31 e non 13.
            //Per questi motivi è meglio tener conto del valore finale
            el.addEventListener('focusout', (event) => {
                var oldValue=event.target.value+'';

                event.preventDefault();
                event.target.value=checkInputAsInteger(oldValue, 0);
                vnode.elm.dispatchEvent(new Event('input'));

            });
            // //Evento scatenato quando si toglie il focus dall'input. Se l'utente ha lasciato l'input vuoto, inserisce automaticamente il valore 0
            // el.addEventListener('change', (event) => {
            //     var oldValue = event.target.value + '';
            //     if (oldValue == "") {
            //         event.target.value = 0;
            //     }

            // });
        },
    });

    Vue.directive('range', {
        inserted(el, binding, vnode) {
            const { min=1, max=365 }=binding.value||{};

            //Evento scatenato dopo l'input: rimuove tutti i caratteri che non sono numeri, corregge il range e permette la cancellazione
            //L'evento beforeinput non va bene perchè non tiene conto del cambiamento dei dati attraverso le frecce (esempio 1) o l'inserimento di un numero non alla fine (esempio 2).
            //Esempio 1: Se il valore attuale è di 200 e si premeva la freccia in avanti, si concatenava 200 a 201, formando il numero 200201. 
            //Questo valore viene corretto con il massimo. Invece si voleva semplicemente sostituire 200 con 201.
            //Esempio 2: Se il valore attuale è di 3, ma si vuole il numero 13, l'utente deve aggiungere 1 davanti, ma 1 veniva concatenato dopo il 3, ottenendo 31 e non 13.
            //Per questi motivi è meglio tener conto del valore finale            
            el.addEventListener('focusout', (event) => {
                let value=event.target.value;

                //var newChar = event.data;
                value=checkInputAsInteger(value, min);

                event.preventDefault();
                if (value<min) {
                    event.target.value=min;
                } else if (value>max) {
                    event.target.value=max;
                } else {
                    event.target.value=value;
                }

                vnode.elm.dispatchEvent(new Event('input'));

                // Sincronizza il valore con v-model
                //vnode.elm.dispatchEvent(new Event('input'));
                //event.preventDefault();

            });

            //Evento scatenato quando si toglie il focus dall'input. Se l'utente ha lasciato l'input vuoto, inserisce automaticamente il valore 0
            // el.addEventListener('change', (event) => {
            //     var oldValue = event.target.value + '';
            //     if (oldValue == "") {
            //         event.target.value = min;
            //     }

            // });
            /*el.addEventListener('beforeinput', (event) => {
                var oldValue = event.target.value + '';
                var newChar = event.data;
                var newValue = checkInputAsInteger(oldValue, newChar, min);

                event.preventDefault();
                if (newValue < min) {
                    event.target.value = min;
                } else if (newValue > max) {
                    event.target.value = max;
                } else {
                    event.target.value = newValue;
                }

                // Sincronizza il valore con v-model
                vnode.elm.dispatchEvent(new Event('input'));
            });*/
        }
    });



    /***************************************************STRING******************************************************************/
    Vue.directive("fsitem", {
        inserted(el, _, vnode) {
            el.addEventListener("focusout"/*'beforeinput'*/, (event) => {

                let value=event.target.value;
                //Gli elementi che dovranno essere nomi di file o cartelle 
                value=value.validateFSItem();
                event.target.value=value;

                // Sincronizza il valore con v-model
                vnode.elm.dispatchEvent(new Event('input'));
            });
        }
    });

    Vue.directive("path", {

        inserted(el, binding, vnode) {
            var type=binding.value;
            var slash=type.getSeparator()


            el.addEventListener("focusout", (event) => {

                let value=event.target.value;

                event.target.value=value.validatePath(type, slash);

                // Sincronizza il valore con v-model
                vnode.elm.dispatchEvent(new Event('input'));
            });

            // el.addEventListener("focusout"/*'beforeinput'*/, (event) => {
            //     let value = event.target.value;
            //     event.target.value = value.trimEnd(slash);
            //     var fakeEvent = new Event('input');
            //     fakeEvent.afterMouseOut = true;
            //     vnode.elm.dispatchEvent(fakeEvent);
            // });
        }
    });


    Vue.directive('disable-tooltip', {
        bind(el, binding, vnode) {

            const updateTooltip=(updateEl, updateBinding) => {

                //const isDisabled=updateEl.disabled;
                 const isDisabled =
                updateEl.disabled === true ||
                updateEl.classList.contains('disabled');

                el.removeAttribute('title');

                if (isDisabled) {
                    var message;
                    if (updateBinding.arg) {
                        //Valore dinamico : v-disable-tooltip:[nome_variabile]
                        message=vnode.context[updateBinding.arg];
                    }
                    else if (updateBinding.value) {
                        //Valore statico: v-disable-tooltip="[valore_statico]"
                        message=updateBinding.value;
                    } else {
                        //nessun messaggio passato
                        return;
                    }

                    if (!isValid(message)) {
                        return;
                    }
                    el.setAttribute('title', message);
                }

                el.setAttribute('aria-disabled', isDisabled);
            };

            // Salva la funzione così possiamo usarla in `update` e `unbind`
            el.__updateTooltip__=updateTooltip;

            // Chiama subito all’inizio
            updateTooltip(el, binding);

            // Osserva cambiamenti all'attributo "disabled"
            const observer=new MutationObserver(mutations => {
                for (const mutation of mutations) {
                    if (mutation.type==='attributes'&&mutation.attributeName==='disabled') {
                        updateTooltip(el, binding);
                    }
                }
            });

            observer.observe(el, {
                attributes: true,
                attributeFilter: ['disabled']
            });

            el.__observer__=observer;
        },

        // In update lo richiamiamo comunque per sicurezza
        update(el, binding) {
            el.__updateTooltip__?.(el, binding);
        },

        unbind(el) {
            el.__observer__?.disconnect();
            delete el.__observer__;
            delete el.__updateTooltip__;
        }
    });

    Vue.directive("no-autocomplete", {
        bind(el, binding) {
            const metroIcon = binding?.value;
            const input=el.tagName==='INPUT'? el:el.querySelector('input');
            if (!input) return;

            input.setAttribute('autocomplete', 'nope');
            input.setAttribute('data-autocomplete', 'nope');
            input.setAttribute('data-default-value', '');
            if(isValid(metroIcon)){
                input.setAttribute("data-prepend", "<span class='"+metroIcon+"'></span>");
            }
            input.readOnly=true;

            const onFocus=(e) => {
                setTimeout(() => e.target.removeAttribute('readonly'), 0);
            };

            input.addEventListener('focus', onFocus, { passive: true });
            input.__afg_onFocus__=onFocus;
        },
        unbind(el) {
            const input=el.tagName==='INPUT'? el:el.querySelector('input');
            if (input&&input.__afg_onFocus__) {
                input.removeEventListener('focus', input.__afg_onFocus__);
                delete input.__afg_onFocus__;
            }
        }
    });
}